/*
  SDS Cross-sell popup
  --------------------------------------------------------------------------
  On a product page that has add-ons (snippets/sds-crosssell-popup renders the
  data + modal), show a modal when THIS product is added to the cart, offering
  its companion products with benefit badges. One-click "Add" posts to
  /cart/add.js, so the core-charge auto-deposit (sds-core-deposit.js) still runs.

  Safe by design: everything is guarded; if the data is missing or anything
  throws, it does nothing and the normal cart flow is untouched.

  Loaded site-wide (sds-vehicle-bar.liquid) but only activates on a page that
  has #sds-xsell-data, i.e. a product page with add-ons configured.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function badgeClass(txt) {
    var t = (txt || '').toLowerCase();
    if (/power|hp|torque|boost|traction|wheel hop|hook|launch/.test(t)) return 'sds-xs__badge--power';
    if (/mpg|fuel|econom|mileage/.test(t)) return 'sds-xs__badge--mpg';
    if (/reliab|protect|life|durab|longev|safe|tough|forged|built|heavy.?duty/.test(t)) return 'sds-xs__badge--reliability';
    if (/air|flow|breath|intake|cool/.test(t)) return 'sds-xs__badge--air';
    if (/tow|haul|load/.test(t)) return 'sds-xs__badge--tow';
    if (/tire|stance|ride|steer|roll|geometry|handl|wander|articul|lift|level/.test(t)) return 'sds-xs__badge--susp';
    if (/install|easy|fit|bolt|plug/.test(t)) return 'sds-xs__badge--install';
    return '';
  }

  var activeCtx = null;

  function boot(opts) {
    opts = opts || {};
    var myCtx = {};
    activeCtx = myCtx;
    var dataEl, items, root, grid;
    try {
      dataEl = document.getElementById('sds-xsell-data');
      if (!dataEl) return;
      items = JSON.parse(dataEl.textContent || '[]');
      if (!Array.isArray(items)) return;
      items = items.filter(function (it) { return it && it.available && it.variant_id; });
      if (!items.length) return;
      root = document.querySelector('[data-sds-xs]');
      grid = root && root.querySelector('[data-xs-grid]');
      if (!root || !grid) return;
    } catch (e) { return; }

    // Variant ids that count as "this product" (ignore related-product quick-adds)
    var mainIds = {};
    (dataEl.getAttribute('data-variant-ids') || '').split(',').forEach(function (id) {
      id = (id || '').trim(); if (id) mainIds[id] = true;
    });

    // added-product name
    var nameEl = root.querySelector('[data-xs-added-name]');
    if (nameEl) nameEl.textContent = dataEl.getAttribute('data-added-name') || 'Item';

    // ---- render cards ----
    items.forEach(function (it) {
      var card = document.createElement('div');
      card.className = 'sds-xs__card';

      var badgesHtml = '';
      if (Array.isArray(it.badges)) {
        it.badges.slice(0, 3).forEach(function (b) {
          if (!b) return;
          var span = document.createElement('span');
          span.className = 'sds-xs__badge ' + badgeClass(b);
          span.textContent = b;
          badgesHtml += span.outerHTML;
        });
      }

      var thumb = it.image ? '<img class="sds-xs__thumb" src="' + it.image + '" alt="" loading="lazy">' : '<span class="sds-xs__thumb"></span>';
      var nameLink = '<a href="' + it.url + '" target="_blank" rel="noopener">' + escapeHtml(it.title) + '</a>';

      var action;
      if (it.multi) {
        action = '<a class="sds-xs__opts" href="' + it.url + '" target="_blank" rel="noopener">Choose options</a>';
      } else {
        action = '<button type="button" class="sds-xs__add" data-xs-add="' + it.variant_id + '"' +
          (it.dep_variant ? ' data-xs-dep="' + it.dep_variant + '" data-xs-depqty="' + (it.dep_qty || 1) + '"' : '') + '>Add</button>';
      }

      card.innerHTML =
        thumb +
        '<div class="sds-xs__info">' +
          '<p class="sds-xs__name">' + nameLink + '</p>' +
          (badgesHtml ? '<div class="sds-xs__badges">' + badgesHtml + '</div>' : '') +
          '<span class="sds-xs__price">' + escapeHtml(it.price || '') + '</span>' +
        '</div>' +
        '<div class="sds-xs__actions">' + action + '</div>';

      grid.appendChild(card);
    });

    // ---- add-on one-click add ----
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-xs-add]');
      if (!btn || btn.disabled) return;
      var vid = parseInt(btn.getAttribute('data-xs-add'), 10);
      if (!vid) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Adding…';
      // Core-charge companions carry the same hidden properties as the product
      // form, so sds-core-deposit.js adds the refundable deposit in this same call.
      var xsProps = { _xsell: '1' };
      var xsDep = btn.getAttribute('data-xs-dep');
      if (xsDep) { xsProps._core_deposit_variant = xsDep; xsProps._core_qty = btn.getAttribute('data-xs-depqty') || '1'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: xsProps }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        btn.textContent = 'Added ✓';
        btn.classList.add('sds-xs__add--done');
        track('sds_xsell_add', { item_id: String(vid), source_product: dataEl.getAttribute('data-added-name') || '' });
        // cart:refresh re-renders the drawer contents from the server (no detail,
        // unlike cart:change which requires detail.cart). It does NOT refresh the
        // header count bubble, so update that directly from a fresh /cart.js.
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e3) {}
        suppressDrawerBurst(); // the refresh/add can re-open the theme drawer; keep our popup on top
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (c) { return c.json(); })
          .then(function (cart) {
            document.querySelectorAll('cart-count').forEach(function (el) {
              try { el.itemCount = cart.item_count; } catch (e4) { try { el.textContent = cart.item_count; } catch (e5) {} }
            });
          }).catch(function () {});
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
    });

    // ---- show / close ----
    var triggered = false, pending = false, pendingTimer = null;
    // The theme pops its own cart-notification-drawer on add; hide it so our
    // popup is the only thing on screen. Burst to beat the open animation.
    function hideDrawers() {
      ['cart-notification-drawer', 'cart-drawer'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          try { if (typeof el.hide === 'function') el.hide(); else if (typeof el.close === 'function') el.close(); } catch (e) {}
          try { el.removeAttribute('open'); el.setAttribute('aria-hidden', 'true'); el.classList.remove('is-open', 'active', 'open'); } catch (e) {}
        });
      });
    }
    function suppressDrawerBurst() { [0, 120, 300, 600].forEach(function (ms) { setTimeout(hideDrawers, ms); }); }
    var dialog = root.querySelector('[role="dialog"]');
    var lastFocus = null;
    function focusables() {
      return Array.prototype.filter.call(
        (dialog || root).querySelectorAll('a[href], button:not([disabled])'),
        function (el) { return el.offsetParent !== null; }
      );
    }
    // Companions already in the cart show "In cart" instead of Add.
    function markInCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (li) { have[li.variant_id] = true; });
          grid.querySelectorAll('[data-xs-add]').forEach(function (b) {
            if (have[b.getAttribute('data-xs-add')] && !b.classList.contains('sds-xs__add--done')) {
              b.disabled = true;
              b.textContent = 'In cart';
              b.classList.add('sds-xs__add--done');
            }
          });
        }).catch(function () {});
    }
    function show() {
      if (triggered) return;
      triggered = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      suppressDrawerBurst();
      markInCart();
      track('sds_xsell_view', { source_product: dataEl.getAttribute('data-added-name') || '', companions: items.length });
      setTimeout(function () { var f = focusables(); if (f.length) f[0].focus(); }, 50);
    }
    function close() {
      root.hidden = true;
      track('sds_xsell_close', { source_product: dataEl.getAttribute('data-added-name') || '' });
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      try { if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus(); } catch (e) {}
    }
    root.querySelectorAll('[data-xs-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (activeCtx !== myCtx || root.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!dialog || !dialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Arm the trigger only on a user add of THIS product (not related-product adds).
    document.addEventListener('click', function (e) {
      if (activeCtx !== myCtx) return;
      var btn = e.target.closest('button, input[type="submit"]');
      if (!btn) return;
      if (btn.closest('[data-sds-xs]')) return;           // not the popup's own buttons
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form && btn.form && /\/cart\/add/.test(btn.form.getAttribute('action') || '')) form = btn.form;
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var vid = idInput && String(idInput.value).trim();
      if (!vid || !mainIds[vid]) return;                  // only this product's form
      pending = true;
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function () { pending = false; }, 6000); // arm window
    }, true);

    function onCartEvent() {
      if (activeCtx !== myCtx) return;
      if (!pending || triggered) return;
      pending = false;
      clearTimeout(pendingTimer);
      // let the theme's own add settle first
      setTimeout(show, 150);
    }
    ['variant:add', 'cart:add', 'on:cart:add', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, onCartEvent);
    });

    // Collection-page mode: the add already happened; show once it is in the cart.
    if (opts.showWhenInCart) {
      var tries = 0;
      (function check() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (li) { return mainIds[String(li.variant_id)]; });
            if (inCart) show();
            else if (++tries < 8) setTimeout(check, 400);
          }).catch(function () {});
      })();
    }
  }

  ready(function () { boot(); });

  // ---- Collection / search pages: quick-add on a product card ----
  var xsCache = {};
  function injectFrom(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var data = doc.getElementById('sds-xsell-data');
    var pop = doc.querySelector('[data-sds-xs]');
    if (!data || !pop) return false;
    document.querySelectorAll('[data-xs-injected]').forEach(function (n) { n.remove(); });
    var st = Array.prototype.filter.call(doc.querySelectorAll('style'), function (x) { return /\.sds-xs\s*\{/.test(x.textContent); })[0];
    var nodes = [data, pop];
    if (st) nodes.push(st);
    nodes.forEach(function (n) {
      var c = document.importNode(n, true);
      c.setAttribute('data-xs-injected', '1');
      if (c.id === 'sds-xsell-data') c.setAttribute('id', 'sds-xsell-data');
      document.body.appendChild(c);
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    try {
      if (document.querySelector('#sds-xsell-data:not([data-xs-injected])')) return; // product page handles itself
      var btn = e.target.closest('button, input[type="submit"]');
      if (!btn) return;
      var card = btn.closest('product-card');
      var form = btn.closest('form[action*="/cart/add"]');
      if (!card || !form) return;
      var handle = card.getAttribute('handle');
      if (!handle) return;
      var p = xsCache[handle] || (xsCache[handle] = fetch('/products/' + encodeURIComponent(handle)).then(function (r) { return r.text(); }));
      p.then(function (html) {
        if (!injectFrom(html)) return;
        boot({ showWhenInCart: true });
      }).catch(function () {});
    } catch (err) {}
  }, true);

  // Analytics: GA4 via gtag when present, always mirrored to dataLayer.
  function track(name, params) {
    try {
      params = params || {};
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
})();
